module.exports = __webpack_public_path__ + "static/img/share_ic3.19b0a78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharedHome/share_ic3.png
// module id = 3Nnm
// module chunks = 1